import { render, staticRenderFns } from "./summary.vue?vue&type=template&id=22935f78&scoped=true"
import script from "./summary.vue?vue&type=script&lang=ts&setup=true"
export * from "./summary.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./summary.vue?vue&type=style&index=0&id=22935f78&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22935f78",
  null
  
)

export default component.exports